/*
 * Copyright (c) 2024 CalAmp Corp. All Rights Reserved
 */
import React, {useEffect, useState} from 'react';
import isUndefined from 'lodash.isundefined';
import {translate} from '@ion/core/src/locale/locale';
import IonSnackbar from '@ion/dls/src/notifications/IonSnackbar';
import {Platform} from '@ion/services/src/graphql/types';

type CreateJobDetailsFormErrorProps = {
  isFetched: boolean;
  isError: boolean;
  fileTypes: Platform[];
  errorResult?: object;
  resetError?: () => void;
};

const getInfoMessage = (isError: boolean, errorResult: object): string => (
  translate(`common:compatibleFiles.${isError && isUndefined(errorResult) ? 'errorMessage' : 'noFiles'}`)
);

export const CreateJobDetailsFormError = ({
  isFetched,
  isError,
  fileTypes,
  errorResult,
  resetError
}: CreateJobDetailsFormErrorProps) => {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setShowError(isError || (isFetched && !isError && fileTypes?.length === 0));
  }, [isError, isFetched, fileTypes]);

  const onDismissError = function() {
    setShowError(false);
    resetError?.();
  };
  
  return (
    <>
      {showError && (
        <IonSnackbar show={showError}
          message={getInfoMessage(isError, errorResult)}
          actionLabel={translate('common:dismiss')}
          onAction={onDismissError} />
      )}
    </>
  );
};

export default CreateJobDetailsFormError;
